<div class="main" fxLayout="column">
  <mat-dialog-content>
    <p><strong>{{data}}</strong></p>
  </mat-dialog-content>
  <div class="buttondiv" fxLayout="row" fxFlexAlign="stretch">
    <button class="yesButton" fxFlexAlign="flex-start" (click)="Confirm()">{{'COMMON.YES' | i18next }}</button>
    <button class="noButton" fxFlexAlign="flex-end" (click)="Discline()">{{'COMMON.NO' | i18next }}</button>
  </div>
</div>
